import React, { useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";

// common
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

const PRIVACY_TEXT = [
  {
    title: "제1조 개인정보의 수집",
    contents: [
      {
        num: "1",
        text: `회사는 개인정보를 수집하는 경우에는 반드시 사전에 이용자에게 해당 사실을 알리고 동의를 구하고 있으며, 이용자가 직접 정보를 입력하는 방법으로 수집합니다.`,
      },
      {
        num: "2",
        text: `고객센터를 통한 상담 과정에서 웹페이지, 메일, 팩스, 전화 등을 통해 이용자의 개인정보가 수집될 수 있습니다.`,
      },
      {
        num: "3",
        text: `오프라인에서 진행되는 이벤트, 세미나 등에서 서면을 통해 개인정보가 수집될 수 있습니다.`,
      },
      {
        num: "4",
        text: `회사와 제휴한 외부 기업이나 단체로부터 개인정보를 제공받을 수 있으며, 이러한 경우에는 정보통신망법 또는 개인정보 보호법에 따라 제휴된 외부 기업이나 단체가 이용자로부터 개인정보 제공 동의 등을 받은 후에 회사에 제공합니다.`,
      },
      {
        num: "5",
        text: `기기정보와 같은 생성정보는 PC웹, 모바일 웹/앱 이용 과정에서 자동으로 생성되어 수집될 수 있습니다.`,
      },
    ],
  },

  {
    title: "제2조 개인정보의 수집항목 및 이용목적",
    contents: [
      {
        num: "0",
        text: `회사는 아래와 같은 목적을 위해 최소한의 개인정보를 수집합니다.`,
        table: (
          <div className="table-wrapper">
            <table>
              <tbody>
                <tr>
                  <th>목적</th>
                  <th>자세한 내용</th>
                </tr>
                <tr>
                  <td>1. 서비스 제공</td>
                  <td>
                    - 이용자가 제공한 정보를 기반으로 연동 센터를 추천하고, 연동된 센터의
                    회원정보와의 매칭, 피트니스 서비스의 스케쥴 예약, 구매, 내 운동기록 관리,
                    커뮤니티 등의 서비스 기능 제공을 위해 개인정보를 수집합니다.
                  </td>
                </tr>
                <tr>
                  <td>2. 서비스 개발 및 개선</td>
                  <td>
                    - 인구통계학적 분석, 서비스 방문 및 이용기록의 분석, 건강관리 및 의료 서비스
                    연구, 교육용 분석, 개인정보 및 건강정보에 기반한 맞춤형 개인 서비스 개발 및 제공
                    등 - 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호
                    측면의 서비스 환경 구축, 맞춤형 서비스 제공, 서비스 개선에 활용
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
      {
        num: "0",
        text: `필수 수집 항목`,
        table: (
          <div className="table-wrapper">
            <table>
              <tbody>
                <tr>
                  <th>항목 구분</th>
                  <th>수집항목</th>
                </tr>
                <tr>
                  <td>일반정보</td>
                  <td>아이디, 비밀번호, 이메일, 이름, 성별, 생년, 휴대전화번호, 이용기기정보</td>
                </tr>
                <tr>
                  <td>기타</td>
                  <td>
                    서비스 이용 또는 업무처리 과정에서 자동으로 생성되어 수집되는 정보-접속IP 정보,
                    서비스 이용 기록(로그데이터, 쿠키, 이용시간 등) 등.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
      {
        num: "0",
        text: `선택 수집 항목`,
        table: (
          <div className="table-wrapper">
            <table>
              <tbody>
                <tr>
                  <th>항목 구분</th>
                  <th>수집항목</th>
                </tr>
                <tr>
                  <td>직업 채용 정보</td>
                  <td>근무기록, 경력</td>
                </tr>
                <tr>
                  <td>기타</td>
                  <td>배송지 주소, 프로필 사진</td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
    ],
  },
  {
    title: "제3조 개인정보의 보관과 파기",
    contents: [
      {
        num: "0",
        text: `회사는 원칙적으로 관련 법령상 보존의무가 있는 경우가 아닌 한 회원 탈퇴 시 또는 서비스
        이용 동의 철회 시 등 개인정보 수집 및 이용목적이 달성된 후에는 개인정보를 지체 없이
        파기합니다. 단, 아래와 같이 관계법령의 규정에 의하여 수집 및 이용 목적 달성 후에도 일정
        기간 계속하여 보존할 필요가 있는 경우, 회사는 해당 기간 동안 개인정보를 보관합니다.`,
        table: (
          <div className="custom-table">
            <table>
              <tbody>
                <tr>
                  <th>보유항목</th>
                  <th>보유기간 (사유발생 일로부터)</th>
                  <th>법적근거</th>
                </tr>
                <tr>
                  <td>계약 또는 청약철회 등에 관련된 기록</td>
                  <td>5년</td>
                  <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                </tr>
                <tr>
                  <td>대금결제 및 재화 등의 공급에 관한 기록</td>
                  <td>5년</td>
                  <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                </tr>
                <tr>
                  <td>소비자의 불만 또는 분쟁처리에 관한 기록</td>
                  <td>3년</td>
                  <td>전자상거래 등에서의 소비자보호에 관한 법률</td>
                </tr>
                <tr>
                  <td>신용정보의 수집/처리 및 이용 등에 관한 기록</td>
                  <td>3년</td>
                  <td>신용정보의 이용 및 보호에 관한 법률</td>
                </tr>
                <tr>
                  <td>이용자의 서비스 이용 관련 접속기록(로그인 기록)</td>
                  <td>3개월</td>
                  <td>통신비밀보호법</td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },
      {
        num: "0",
        text: <p className="bold-text">파기절차와 방법</p>,
      },
      {
        num: "0",
        text: `- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.`,
      },
      {
        num: "0",
        text: `- 전자적 파일 형태로 저장된 개인정보는 재생 또는 복구할 수 없는 기술적 방법을 사용하여
            안전하게 삭제합니다.`,
      },
    ],
  },
  {
    title: "제4조 제3자에 대한 제공",
    contents: [
      {
        num: "1",
        text: `회사는 이용자의 개인정보를 "제2조 개인정보의 수집항목 및 이용목적 "에서 고지한 범위를 넘어 이용하거나 타인 또는 타기업, 기관에 제공하지 않습니다.`,
      },
      {
        num: "2",
        text: (
          <>
            단, 다음은 예외로 합니다. <br />
            가. 관계법령에 의하여 수사상의 목적으로 관계기관으로부터의 요구가 있을 경우 <br />
            나. 통계작성, 학술연구나 시장조사 등을 위하여 특정 개인을 식별할 수 없는 형태로 광고주,
            협력사나 연구단체 등에 제공하는 경우 <br />
            다. 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우 회사는, 상기사항에 의해
            개인정보를 제공하는 경우에도 본래의 수집 및 이용 목적에 반하여 무분별하게 정보가
            제공되지 않도록 최대한 노력하겠습니다.
          </>
        ),
      },
      {
        num: "3",
        text: (
          <>
            회사는 아래와 같이 이용자의 개인정보를 제3자에게 제공합니다. <br />
            가. 개인정보를 제공 받는 자 : 바디코디 서비스 이용 회원 및 정산관련 정보 취급자 <br />
            나. 제공받는 자의 개인정보 이용목적 : 피트니스 서비스 선택 및 이용 및 판매 대금이나
            수수료 제공 지급 <br />
            다. 제공하는 개인정보 항목 : (1) 가맹점/강사 매칭 및 식별을 위한 이름, 전화번호 라.
            제공받는 자의 보유 및 이용기간 : 관련 법령상 보존의무가 있는 경우가 아닌 한 회원의 탈퇴
            시 또는 서비스 이용 동의 철회 시까지 보유 및 이용
          </>
        ),
      },
    ],
  },

  {
    title: "제5조 개인정보의 취급 위탁",
    contents: [
      {
        num: "0",
        text: `회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리 업무를 위탁할 수
        있습니다. 회사는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외
        개인정보 처리금지, 기술적.관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리.감독,
        손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게
        처리하는지를 감독하고 있습니다. 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본
        개인정보 처리방침을 통하여 공개하도록 하겠습니다.`,
        table: (
          <div className="custom-table">
            <table>
              <tbody>
                <tr>
                  <th>수탁업체</th>
                  <th>위탁업무 내용</th>
                  <th>개인정보의 보유 및 이용기간</th>
                </tr>
                <tr>
                  <td>토스페이먼츠</td>
                  <td>결제 서비스 제공</td>
                  <td rowSpan={7}>회원탈퇴시 혹은 위탁계약 종료시까지</td>
                </tr>
                <tr>
                  <td>(주)알리는사람들</td>
                  <td>기기인증 및 사용자 인증용 문자전송</td>
                </tr>
                <tr>
                  <td>모두싸인</td>
                  <td>가맹점과 회원간 전자계약 및 전자계약 서명시</td>
                </tr>
                <tr>
                    <td>네이버파이낸셜(주)</td>
                    <td>결제 서비스 제공</td>
                </tr>
                <tr>
                    <td>네이버클라우드(주)</td>
                    <td>기기인증 및 사용자인증용 문자전송</td>
                </tr>
                <tr>
                    <td>(주)슈프리마</td>
                    <td>회원의 가맹점 출입제어</td>
                </tr>
                <tr>
                    <td>(주)케이에스넷</td>
                    <td>가맹점과 회원간 카드결제</td>
                </tr>
              </tbody>
            </table>
          </div>
        ),
      },

      {
        num: "0",
        text: `- 수탁자에 공유되는 정보는 당해 목적을 달성하기 위하여 필요한 최소한의 정보에 국한됩니다. 또한 이용자의 서비스 요청에 따라 해당하는 업체에 선택적으로 개인정보가 제공되고 있습니다.`,
      },
      {
        num: "0",
        text: `- 위탁 업체 리스트는 해당 서비스 변경 및 계약기간에 따라 변경될 수 있으며 변경 시 서비스의 공지사항을 통해 사전 공지합니다.`,
      },
      {
        num: "0",
        text: `- 단기 이벤트의 경우, 매 이벤트 참여시에 개별 공지됩니다.`,
      },
    ],
  },
  {
    title: "제6조 이용자의 권리와 의무",
    contents: [
      {
        num: "0",
        text: <p className="bold-text">정보주체의 권리</p>,
      },
      {
        num: "0",
        text: (
          <>
            이용자는 개인정보주체로서 언제든지 회사가 제공하는 서비스 고객센터와 이용문의 기능을
            통해, 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다. 정보주체의
            법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우, 개인정보
            보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하여야 합니다.
            <br /> - 개인정보 열람요구
            <br /> - 오류 등이 있을 경우 정정 요구
            <br /> - 삭제요구
            <br /> - 처리정지 요구
            <br /> - 개인정보 동의 철회
          </>
        ),
      },
      {
        num: "0",
        text: (
          <>
            <br />
            이용자 및 법정대리인은 등록되어 있는 이용자 본인의 개인정보 관련하여, 언제든지 개인정보
            열람/정정·삭제/처리정지/동의 철회를 요청할 수 있습니다. 이를 위하여
            대표전화(02-2676-6060 ) 또는 개인정보 보호 책임자에게 서면, FAX 또는 이메일로 연락하시면
            지체 없이 조치하겠습니다.
          </>
        ),
      },
      {
        num: "0",
        text: (
          <>
            <br />
            다만, 회사는 다음에 해당하는 경우에는 개인정보의 전부 또는 일부에 대하여
            열람/정정·삭제를 거절할 수 있습니다.
            <br /> - 법률에 따라 열람이 금지되거나 제한되는 경우
            <br /> - 다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을
            부당하게 침해할 우려가 있는 경우
          </>
        ),
      },
      {
        num: "0",
        text: <p className="bold-text">이용자의 책임과 의무</p>,
      },
      {
        num: "0",
        text: (
          <>
            이용자의 개인정보를 최신의 상태로 정확하게 입력해 주셔야 합니다. 이용자가 입력한
            부정확한 정보로 인해 발생하는 사고의 책임은 이용자 자신에게 있으며 타인 정보의 도용 등
            허위정보를 입력할 경우 회원 자격이 상실될 수 있습니다.
            <br /> 이용자는 개인정보를 보호받을 권리와 함께 스스로를 보호하고 타인의 정보를 침해하지
            않을 의무도 가지고 있습니다. 비밀번호를 포함한 이용자의 개인정보가 유출되지 않도록
            조심하시고 게시물을 포함한 타인의 개인정보를 훼손하지 않도록 유의해 주십시오. 만약 이
            같은 책임을 다하지 못하고 타인의 정보 및 존엄성을 훼손할 시에는 「정보통신망 이용촉진 및
            정보보호 등에 관한 법률」 등에 의해 처벌받을 수 있습니다.
          </>
        ),
      },
    ],
  },
  {
    title: "제7조. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항",
    contents: [
      {
        num: "1",
        text: `회사는, 이용자의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'를 운용합니다.
        쿠키는 회사의 홈페이지, 웹서비스, 모바일앱을 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터나 모바일 기기의 하드디스크에 저장됩니다. 회사는, 이용자가 서비스에 접속한 상태에서 사용자 인증을 위하여 쿠키를 이용하고 있습니다. 쿠키 이용에 대한 선택권은 이용자가 가지고 있습니다. 이용자의 웹브라우저에서 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부하는 등의 옵션을 선택하실 수 있습니다. 설정방법은 인터넷 익스플로러의 경우 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보 에서 선택하실 수 있습니다. 단, 쿠키의 저장을 거부하는 옵션을 선택하시는 경우에는 서비스 이용에 불편이 야기될 수 있습니다.`,
      },
      {
        num: "2",
        text: (
          <>
            회사는 Google, Inc.(이하 “Google”이라 합니다)가 제공하는 서비스인 Google Analytics와
            Firebase 를 이용해 이용자의 서비스 이용행태를 분석합니다. 회사는 이용자의 정보를,
            비식별화조치 후 미국 내 Google 서버로 전송합니다. Google 은 회사를 대신해 정보를
            처리하여 이용자의 서비스 사용을 분석합니다. Google 은 이 과정에서 개인 식별이 가능한
            어떠한 정보도 처리하지 않습니다. Google 의 정보 처리를 원하지 않는 경우
            tools.google.com/dlpage/gaoptout 에서 이용자의 웹 브라우저에 대한 부가 기능을 다운로드
            및 설치하여 Google 의 정보 처리를 거부할 수 있습니다. Google 의 정보 처리에 관한 보다
            자세한 내용은
            <br />
            <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a> 을
            참고하시기 바랍니다.
          </>
        ),
      },
      {
        num: "3",
        text: (
          <>
            회사는, 다음 각 호와 같은 목적으로 이용자의 휴대폰 기기 종류, OS 타입, IP 주소, 단말기
            아이디 등의 기기 정보를 수집합니다. 또한 쿠키, 광고 식별자, 모바일 애플리케이션 아이디
            등 기기에서 자동적으로 생성된 정보를 수집합니다.
            <br /> 1. 서비스의 비인가 또는 부정 사용 예방
            <br /> 2. 이용자 기기에 최적화된 서비스 제공
            <br /> 3. 이용 센터의 회원정보와의 매칭이나, 연동 신청자의 확인
          </>
        ),
      },
      {
        num: "4",
        text: (
          <>
            이용자는, 아래와 같은 설정을 통해 광고 식별자의 수집을 거부할 수 있습니다.
            <br /> 1. 안드로이드폰 : 구글설정 광고 → 광고 맞춤 설정 선택 또는 해제
            <br /> 2. 아이폰 : 아이폰설정 → 개인정보보호 → 광고 → 광고 추적 제한
          </>
        ),
      },
    ],
  },
  {
    title: "제8조 개인정보의 안전성 확보 조치",
    contents: [
      {
        num: "0",
        text: `회사는, 개인정보보호법 제 29 조에 따라 다음 각 호와 같이 안전성 확보에 필요한 관리적·기술적·물리적 조치를 하고 있습니다.`,
      },
      {
        num: "1",
        text: (
          <>
            관리적 조치
            <br />
            1. 내부관리계획 수립 및 시행
            <br />
            2. 개인정보 취급 직원의 최소화 및 교육: 개인정보를 취급하는 직원을 지정하고 담당자에
            한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고 있습니다.
          </>
        ),
      },
      {
        num: "2",
        text: (
          <>
            - 기술적 조치
            <br /> 1. 개인정보처리시스템 접근권한 관리: 개인정보를 처리하는 데이터베이스시스템에
            대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근 통제를 위하여 필요한
            조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.
            <br /> 2. 개인정보의 암호화: 이용자의 개인정보인 비밀번호는 암호화되어 저장 및 관리되고
            있어 본인만이 알 수 있으며, 중요한 데이터는 파일 및 전송 데이터를 암호화하거나 파일 잠금
            기능을 사용하는 등의 별도 보안기능을 사용하고 있습니다.
            <br /> 3. 해킹 등에 대비한 기술적 대책: 당행은 해킹이나 바이러스 등에 의한 개인정보 유출
            및 훼손을 막기 위하여 보안프로그램을 설치하여 주기적인 갱신·점검을 하며 외부로부터의
            접근이 통제된 구역에 시스템을 설치하는 등 기술적·물리적으로 감시 및 차단하고 있습니다.
          </>
        ),
      },
      {
        num: "3",
        text: (
          <>
            - 물리적 조치 : 자사는 Amazon Web Services (이하 “AWS”) 의 클라우드 서비스상의 대한민국
            리전에 분리된 환경을 구축하여, 서비스를 제공하고 있으며, 이의 서버에 대한 물리적 접근
            통제는 AWS 사의 통제하에 관리되고 있습니다. AWS의 물리적 계층의 보안에 대한 더 자세한
            사항을 알고 싶으시다면,
            <a href="https://aws.amazon.com/ko/security/"> https://aws.amazon.com/ko/security/ </a>
            사이트를 참고하시길 바랍니다. 또한 개인정보 담당 업무 직원들의 근무지인 대한민국 서울
            소재 본사 사무실은 외부인 무단 입출입이 불가능한 사무 공간을 구성하고 있습니다.
          </>
        ),
      },
    ],
  },
  {
    title: "제9조. 개인정보보호 책임자 및 담당자",
    contents: [
      {
        num: "0",
        text: `회사는 이용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보보호책임자를 지정하고 있습니다.`,
      },
      {
        num: "0",
        text: <p className="bold-text">(1) 고객서비스 담당부서</p>,
      },
      {
        num: "0",
        text: (
          <>
            - 고객서비스 담당부서 : 바디코디 운영팀
            <br /> - 카카오톡 채널 : @bodycodi
            <br /> - 이메일 : ask@bodycodi.com`,
          </>
        ),
      },
      {
        num: "0",
        text: <p className="bold-text">(2) 개인정보보호 책임자</p>,
      },
      {
        num: "0",
        text: (
          <>
            - 성명 : 이석훈
            <br /> - 직위 : 대표이사
            <br /> - 전화 : 02-2676-6060
            <br /> - 이메일 : security@bodycodi.com`
          </>
        ),
      },
      {
        num: "0",
        text: <p className="bold-text">(3) 기타 기관</p>,
      },
      {
        num: "0",
        text: (
          <>
            이용자는 회사의 서비스를 이용하며 발생하는 모든 개인정보보호 관련 민원을
            개인정보보호책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에
            대해 신속하게 충분한 답변을 드릴 것입니다. 기타 개인정보침해에 대한 신고나 상담이
            필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
            <br /> - KISA 개인정보침해신고센터 (국번없이 118) /
            <br />
            <a href="http://privacy.kisa.or.kr">http://privacy.kisa.or.kr</a>
            <br /> - 개인정보 분쟁조정위원회 1833-6972 /
            <br />
            <a href="http://kopico.go.kr">http://kopico.go.kr</a>
            <br /> - 대검찰청 사이버수사과 (국번없이) 1301 /
            <br />
            <a href="http://spo.go.kr">http://spo.go.kr</a>
            <br /> - 경찰청 사이버안전국 (국번없이) 182 /
            <br />
            <a href="http://www.police.go.kr/www/security/cyber.jsp">
              http://www.police.go.kr/www/security/cyber.jsp
            </a>
          </>
        ),
      },
    ],
  },
  {
    title: "제10조. 개인정보 처리방침 변경",
    contents: [
      {
        num: "0",
        text: `이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.`,
      },
      {
        num: "0",
        text: (
          <>
            개인정보처리방침 버전번호 : Ver 1.00025
            <br /> 개인정보처리방침 시행일자 : 2023.5.1
          </>
        ),
      },
    ],
  },
];

const PrivacyPop = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "PRIVACY_DETAIL_POP",
      open: { privacyDetailPop: false },
    });
  };

  return (
    <CustomDialog open={state.privacyDetailPop} onClose={handleClose}>
      <PopupHeader title={"개인정보 취급방침"} onClickBack={handleClose} />
      <div className="terms-body">
        <div className="term-text" style={{ marginBottom: 16 }}>
          (주) 레드블루 (이하 “회사”)는 이용자의 개인정보를 중요시하며, 「정보통신망 이용촉진 및
          정보보호 등에 관한 법률」(이하 “정보통신망법”), 「개인정보 보호법」 등 개인정보와 관련된
          법령, 행정안전부, 방송통신위원회, 공정거래위원회 등이 개인정보보호에 관하여 제정한 각종
          가이드라인을 준수하기 위하여 노력하고 있습니다. <br />
          회사는 개인정보 처리방침을 통하여 회사가 이용자로부터 제공받은 개인정보를 어떠한 용도와
          방식으로 이용하고 있으며, 개인정보보호를 위해 어떠한 조치를 취하고 있는지 알려드립니다.
        </div>
        {PRIVACY_TEXT.map((v, index) => {
          return (
            <div className="term-wrapper" key={index}>
              <span className="term-title">{v.title}</span>
              {v.contents.map((c: any, i) => {
                return (
                  <div key={i} className="term-content">
                    {c.num !== "0" && <span className="term-text number-point">{c.num}.</span>}
                    <span className="term-text">
                      {c.text}
                      {c.table && c.table}
                    </span>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </CustomDialog>
  );
};

export default PrivacyPop;
